import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-D_LIh_94.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const PinFilledSize16Component = (props, ref) => (jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.2394 11.15L10.0471 9.80396L13.286 6.566L14.4882 7.76783L15.3367 6.91955L9.08531 0.669983L8.23678 1.51826L9.439 2.72012L6.20008 5.95809L4.85368 5.76579C3.58225 5.5842 2.2995 6.01165 1.39134 6.91954L0.670044 7.64063L4.09613 11.0657L0.672485 14.4884L1.52101 15.3366L4.94466 11.914L8.36405 15.3324L9.08534 14.6113C9.99351 13.7034 10.4211 12.421 10.2394 11.15Z", fill: "var(--magritte-ui-icon-color)" }) }) }));
const PinFilledSize16 = hoc(forwardRef(PinFilledSize16Component), 'PinFilledSize16');

export { PinFilledSize16 as default };
//# sourceMappingURL=PinFilledSize16.js.map
